// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"y--z"};